function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { Link } from 'react-router';
/**
 * URL, 해시태그, 멘션을 링크로 변환하는 함수
 */ export var processTextWithLinks = function(text) {
    // URL, 해시태그, 멘션을 찾기 위한 정규식 패턴
    var splitRegex = /(https?:\/\/[^\s]+|\s+|#\w+|@\w+)/g;
    var urlRegex = /^https?:\/\/[^\s]+$/;
    var hashtagRegex = /^#\w+$/;
    var mentionRegex = /^@\w+$/;
    // 텍스트를 URL, 공백, 해시태그, 멘션으로 분할
    var parts = text.split(splitRegex).filter(Boolean);
    var matches = text.match(splitRegex) || [];
    // 분할된 부분과 일치하는 항목을 결합
    var combined = _to_consumable_array(parts).concat(_to_consumable_array(matches)).filter(Boolean).sort(function(a, b) {
        return text.indexOf(a) - text.indexOf(b);
    });
    // duplicate removed
    var uniqueParts = [];
    for(var i = 0; i < combined.length; i++){
        if (i === 0 || combined[i] !== combined[i - 1]) {
            uniqueParts.push(combined[i]);
        }
    }
    // 레이아웃 생성
    return uniqueParts.map(function(part, i) {
        // URL인 경우 링크로 변환
        if (urlRegex.test(part)) {
            return /*#__PURE__*/ React.createElement("a", {
                key: i,
                href: part,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: function(e) {
                    return e.stopPropagation();
                }
            }, part);
        } else if (part.trim()) {
            // 해시태그와 멘션에 대한 정규식
            var wordsRegex = /(#\w+|@\w+|[^#@\s]+|\s+)/g;
            var words = part.match(wordsRegex) || [];
            // 여러 단어가 있는 경우 각각 처리
            if (words.length > 1) {
                return words.map(function(subPart, j) {
                    // 해시태그인 경우
                    if (hashtagRegex.test(subPart)) {
                        return /*#__PURE__*/ React.createElement(Link, {
                            key: "hashtag-".concat(i, "-").concat(j),
                            to: "/search?q=%23".concat(subPart.substring(1)),
                            onClick: function(e) {
                                return e.stopPropagation();
                            }
                        }, subPart);
                    } else if (mentionRegex.test(subPart)) {
                        // 멘션 처리
                        var mentionParts = subPart.match(/@\w+/g) || [];
                        if (mentionParts.length > 0) {
                            return mentionParts.map(function(mentionPart, k) {
                                return /*#__PURE__*/ React.createElement(Link, {
                                    key: "mention-".concat(i, "-").concat(j, "-").concat(k),
                                    to: "/users/".concat(mentionPart.substring(1)),
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    }
                                }, mentionPart);
                            });
                        }
                    }
                    // 일반 텍스트인 경우
                    return subPart;
                });
            } else if (hashtagRegex.test(part)) {
                return /*#__PURE__*/ React.createElement(Link, {
                    key: "single-hashtag-".concat(i),
                    to: "/search?q=%23".concat(part.substring(1)),
                    onClick: function(e) {
                        return e.stopPropagation();
                    }
                }, part);
            } else if (mentionRegex.test(part)) {
                return /*#__PURE__*/ React.createElement(Link, {
                    key: "single-mention-".concat(i),
                    to: "/users/".concat(part.substring(1)),
                    onClick: function(e) {
                        return e.stopPropagation();
                    }
                }, part);
            }
        }
        // 일반 텍스트나 공백인 경우
        return part;
    });
};
/**
 * 날짜 포맷팅 함수
 */ export var formatDate = function(date) {
    var d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};
/**
 * YouTube URL 확인 함수
 */ export var checkYoutubeUrl = function(url) {
    if (!url) return false;
    return url.includes('youtube.com') || url.includes('youtu.be');
};
